import { render, staticRenderFns } from "./InputWarnings.vue?vue&type=template&id=76a1a312&"
import script from "./InputWarnings.vue?vue&type=script&lang=js&"
export * from "./InputWarnings.vue?vue&type=script&lang=js&"
import style0 from "./InputWarnings.vue?vue&type=style&index=0&id=76a1a312&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports